import { createGlobalStyle } from 'styled-components';
import { maxWidth } from 'config/constants';

export const BarcodeScannerModalGlobalStyle = createGlobalStyle`
  .barcode-scanner__modal {
    max-width: 100vw !important;
    margin: 0 !important;
    padding: 0 !important;
    top: 0 !important;

    .ant-modal-content {
      overflow: hidden;
      padding: 40px 0;
      height: 100dvh;
      border-radius: 0;
      display: flex;
      flex-direction: column;
    }

    .ant-modal-header {
      margin-bottom: 35px;
    }

    .ant-modal-body {
      padding: 0;
      flex: 1;
      display: flex;
      flex-direction: column;
      overflow: hidden;
    }

    .barcode-scanner__camera-container {
      position: relative;
      width: 100%;
      aspect-ratio: 1 / 1;
      background: #000;
      overflow: hidden;

      #barcode-scanner-camera {
        width: 100%;
        height: 100%;

        video {
          width: 100% !important;
          height: 100% !important;
          display: block;
          object-fit: cover;
        }
      }

      .barcode-scanner__gallery-btn {
        position: absolute;
        border-radius: ${(props): number => props.theme.kcc.borderRadius.PILL}px;
        background: ${(props): string => props.theme.kcc.colors.GRAY_600} !important;
        color: #fff;
        line-height: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 10;

        ${maxWidth.l} {
          bottom: 36px;
          left: 36px;
          width: 90px;
          height: 90px;
        }

        ${maxWidth.m} {
          bottom: ${(props): string => props.theme.kcc.spacing.LG};
          left: ${(props): string => props.theme.kcc.spacing.LG};
          width: 48px;
          height: 48px;
        }
      }

.barcode-scanner__permission-denied {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: white;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 16px;
        text-align: center;
        z-index: 5;
      }

      .barcode-scanner__gallery-btn-icon {
        width: 24px;
        height: 24px;
        display: flex;

        svg path {
          stroke: ${(props): string => props.theme.kcc.colors.PRIMARY_KARCHER};
          fill: ${(props): string => props.theme.kcc.colors.PRIMARY_KARCHER};
        }
      }
    }

    .barcode-scanner__modal-text {
      display: flex;
      flex-direction: column;
      gap: ${(props): string => props.theme.kcc.spacing.BASE};
      padding: ${(props): string => props.theme.kcc.spacing.LG};
      padding-bottom: 0;

      p {
        margin-bottom: 0;
      }
    }

    .barcode-scanner__modal-title {
      font-weight: ${(props): number => props.theme.kcc.typography.FONT_WEIGHT.EXTRA_BOLD};
      font-size: ${(props): number => props.theme.kcc.typography.FONT_SIZE.XL}px;
    }

    .barcode-scanner__modal-description {
      font-size: ${(props): number => props.theme.kcc.typography.FONT_SIZE.LG}px;
    }
  }
`;
